export const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="foot1">
          <h1>Menu</h1>
          <p>Home</p>
          <p>My Account</p>
          <p>Shedule</p>
          <p>Editorials</p>
          <p>Archives</p>
          <p>Ranking-Men</p>
          <p>Ranking-Women</p>
          <p>Points Table</p>
          <p>Points Table</p>
        </div>
        <div className="foot2">
          <h1>Top</h1>
          <p>Cricbuzz Plus</p>
          <p>Home</p>
          <p>My Account</p>
          <p>Shedule</p>
          <p>Editorials</p>
          <p>Archives</p>
          <p>Ranking-Men</p>
          <p>Ranking-Women</p>
          <p>Points Table</p>
        </div>
      </div>
    </>
  );
};

export default Footer;
